export enum ClientOtherBuyerRole {
	Recipient = 'Recipient',
	JSTRecipient = 'JSTRecipient',
	VatGroupMemberRecipient = 'VatGroupMemberRecipient',
	Employee = 'Employee'
}
